import { event } from "@foretagsplatsen/yaem";
import ErrorAlert from "./ErrorAlert.js";
import SuccessAlert from "./SuccessAlert.js";
import WarningAlert from "./WarningAlert.js";

/**
 * `AlertBus` has the responsibility to centralize all requests to
 * alert the user. Other components can register to alerts (successes,
 * warnings and errors) to show notifications for example.
 */
export class AlertBus {
	constructor() {
		this._onSuccess = event();
		this._onWarning = event();
		this._onError = event();
	}

	onSuccess(fn) {
		const binding = this._onSuccess.register(fn);

		return () => binding.unbind();
	}

	onWarning(fn) {
		const binding = this._onWarning.register(fn);

		return () => binding.unbind();
	}

	onError(fn) {
		const binding = this._onError.register(fn);

		return () => binding.unbind();
	}

	success(spec) {
		this._onSuccess.trigger(new SuccessAlert(spec));
	}

	successIf(condition, spec) {
		if (!condition) return;
		this.success(spec);
	}

	warning(spec) {
		this._onWarning.trigger(new WarningAlert(spec));
	}

	warningIf(condition, spec) {
		if (!condition) return;
		this.warning(spec);
	}

	error(spec) {
		this._onError.trigger(new ErrorAlert(spec));
	}

	errorIf(condition, spec) {
		if (!condition) return;
		this.error(spec);
	}
}

const alertBus = new AlertBus();

export default alertBus;
